<script lang="typescript">
    import { createEventDispatcher } from 'svelte'
    import ModalPanel from './components/ModalPanel.svelte';

    let dispatch = createEventDispatcher();
    
    export let new_difficulty = 2
    export let new_size = 5

    function newPuzzle() {
        dispatch("close");
        dispatch("newPuzzle", { difficulty: new_difficulty, size: new_size})
    }

    function cancel() {
        dispatch("close");
    }
</script>

<ModalPanel style="top: 50%; left: 50%; transform: translate(-50%, -50%)" on:wantClose={cancel}>
    <div class="new-game">
        <div><label for="difficulty">Difficulty</label><span class="slider-val">{#if new_difficulty == 1}Easy{:else if new_difficulty == 2}Normal{:else if new_difficulty == 3}Hard{/if}</span></div>
        <div><input name="difficulty" type="range" min="1" max="3" bind:value={new_difficulty}></div>
        <div><label for="size">Size</label><span class="slider-val">{new_size} x {new_size}</span></div>
        <div><input name="size" type="range" min="2" max="15" bind:value={new_size}></div>
        <div><button on:click={()=>{ newPuzzle()} }>Start</button></div>
    </div>
</ModalPanel>


<style>
	.new-game {
		width: 250px;
		padding: 1rem;
	}

	.new-game > * {
		margin: 0.75rem;
	}
	.new-game button { margin-top: 1.0rem; }

	.new-game input,
	.new-game button {
		width: 100%;
	}

	.new-game .slider-val {
		float: right;
	}

</style>

